<template>
  <div
    :class="[
      'vouchers-list-item-attempt',
      hasPassed && 'vouchers-list-item-attempt__passed',
      index === 0 && 'vouchers-list-item-attempt__recent',
    ]"
  >
    <p v-if="attemptStartDate" class="vouchers-list-item-attempt__detail">
      {{ attemptStartDate }}
    </p>
    <p class="vouchers-list-item-attempt__detail">
      {{ attemptSubmitDate ? attemptSubmitDate : 'Not yet submitted' }}
    </p>
    <p
      v-if="attemptStatus"
      :class="[
        'vouchers-list-item-attempt__detail',
        attemptStatus !== 'started' &&
          'vouchers-list-item-attempt__detail--status',
      ]"
      :style="`--status-gradient: ${statusGradient}`"
    >
      {{ attemptStatus }}
    </p>
    <button
      v-if="isModalViewable"
      @click="showAttemptScore"
      class="vouchers-list-item-attempt__dots-wrapper"
    >
      <DotIcon class="vouchers-list-item-attempt__dot" />
      <DotIcon class="vouchers-list-item-attempt__dot" />
      <DotIcon class="vouchers-list-item-attempt__dot" />
    </button>
  </div>
</template>

<script>
import { format } from 'date-fns-tz'
import CONSTANTS from '@/constants'
import { hasPassedAttempt } from '@/helpers'
import DotIcon from '@/assets/icons/certifications/dot.svg'

export default {
  name: 'VouchersListItemAttempt',
  components: { DotIcon: { ...DotIcon, name: 'DotIcon' } },
  props: {
    attempt: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      possibleStatus: {
        [CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.IN_PROGRESS]: 'In progress',
        [CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.REVIEW]: 'Pending Review',
        [CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.TIMEDOUT]:
          'Failed (Time expired)',
      },
    }
  },
  computed: {
    attemptStartDate() {
      const { created } = this.attempt
      return this.formatDate(created)
    },
    attemptSubmitDate() {
      const { finished_at } = this.attempt
      if (finished_at && finished_at.length) {
        return this.formatDate(finished_at)
      }
      return finished_at
    },
    hasPassed() {
      return hasPassedAttempt(this.attempt)
    },
    attemptStatus() {
      const { status } = this.attempt
      if (status !== CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.FINISHED) {
        return this.possibleStatus[status] || ''
      }
      if (this.hasPassed) {
        return 'passed'
      }
      return 'failed'
    },
    statusGradient() {
      const gradients = {
        'Failed (Time expired)':
          'linear-gradient(180deg, #E52A2A 0%, #FF5E5E 100%)',
        failed: 'linear-gradient(180deg, #E52A2A 0%, #FF5E5E 100%)',
        'Pending Review': '#EEEEEE',
        'In progress': '#FFFFFF',
        passed: 'linear-gradient(145.56deg, #00DA99 20.53%, #70FFD4 79.76%)',
      }
      return gradients[this.attemptStatus]
    },
    isModalViewable() {
      const { status } = this.attempt
      const unavailableStatus = [
        CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.IN_PROGRESS,
        CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.REVIEW,
        CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.TIMEDOUT,
      ]
      return !unavailableStatus.includes(status)
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'LLL d, yyyy. h:mmaa')
    },
    showAttemptScore() {
      this.$store.dispatch(
        'certifications/setCurrentAttemptScored',
        this.attempt
      )
    },
  },
}
</script>

<style lang="scss">
.vouchers-list-item-attempt {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  border-radius: 10px;
  color: var(--light-blue-gray);
  &__passed {
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    padding: 10px;
  }
  &__recent {
    color: var(--white);
  }
  &__detail {
    font-size: rem(14);
    line-height: 24px;
    margin: 0;
    padding: 0 5px 0 0;
    min-width: 33.33%;
    color: inherit;
    text-transform: capitalize;
    @include tablet {
      font-size: rem(16);
      padding: 0;
    }
    &--status {
      position: relative;
      margin: 0 0 0 15px;
      &:before {
        content: '';
        position: absolute;
        left: -15px;
        top: 3.4px;
        width: 5px;
        height: 17px;
        background: var(--status-gradient);
        border-radius: 10px;
      }
    }
  }
  &__dots-wrapper {
    position: absolute;
    right: 0;
    top: 11px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }
  &__dot {
    margin: 0 2px 0 0;
  }
}
</style>
